<div class="language-switch">
  <ng-select
    bindLabel="language"
    [(ngModel)]="selected"
    (change)="onSelectChange($event)"
    [clearable]="false"
    [searchable]="false"
    [multiple]="false"
    class="custom"
    >
    @for (item of items; track item) {
      <ng-option [value]="item.id">{{ item.language }}</ng-option>
    }
  </ng-select>
</div>
